import {TemplateDocumentData} from 'powtoon-services/content-library/types'

export default ({
  content,
  content: {
    metadata,
    powtoon: {slides}
  },
  thumbs,
  visualStyle,
  name = 'untitled-1',
  originalPowtoonThumb,
  storyElement
}: TemplateDocumentData, created = {}) => ({
  content: {
    ...content,
    metadata: {
      ...metadata,
      studioSettings: {
        default: {
          lastPlayheadPosition: slides.map(slide => slide.duration - 1),
          selectedVisualStyle: visualStyle,
          libraryState: {
            panelId: 'scenes',
            folderId: storyElement || null
          }
        }
      },
      ...created
    }
  },
  name,
  enableRichText: true,
  thumbUrl: originalPowtoonThumb || thumbs?.originalPowtoonThumb?.url
})
